import { StylesConfig } from 'react-select';

/**
 * react-select styling that matches the wave.me `.wm-input` look (used by the
 * platform / location / tag dropdowns, which have no native wave component).
 * References the --wm-* tokens, which wave.css defines on :root.
 */
export const waveSelectStyles: StylesConfig = {
    container: (base) => ({ ...base, margin: 0 }),
    // Fixed height + box-shadow-only focus ring so hover/focus never resize the
    // control (which used to nudge the whole page).
    control: (base, state) => ({
        ...base,
        minHeight: '46px',
        fontSize: '15px',
        backgroundColor: 'var(--wm-surface)',
        borderColor: state.isFocused ? 'var(--wm-accent)' : 'var(--wm-line)',
        borderRadius: 'var(--wm-r-md)',
        boxShadow: state.isFocused ? '0 0 0 3px color-mix(in oklab, var(--wm-accent) 22%, transparent)' : 'none',
        '&:hover': { borderColor: state.isFocused ? 'var(--wm-accent)' : 'var(--wm-line)' },
    }),
    valueContainer: (base) => ({ ...base, padding: '2px 12px' }),
    placeholder: (base) => ({ ...base, color: 'var(--wm-ink-3)' }),
    singleValue: (base) => ({ ...base, color: 'var(--wm-ink)' }),
    menu: (base) => ({
        ...base,
        borderRadius: 'var(--wm-r-md)',
        overflow: 'hidden',
        boxShadow: 'var(--wm-shadow-2)',
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected
            ? 'var(--wm-accent-soft)'
            : state.isFocused
              ? 'var(--wm-soft)'
              : 'transparent',
        color: 'var(--wm-ink)',
        cursor: 'pointer',
    }),
    multiValue: (base) => ({ ...base, backgroundColor: 'var(--wm-soft)', borderRadius: '99px' }),
    multiValueLabel: (base) => ({ ...base, color: 'var(--wm-ink-2)' }),
};
